import auth from './auth';
import clients from './clients';
import overview from './overview';
import partner from './partner';
import product from './product';
import routes from './routes';
import schedules from './schedule';
import vendingMachine from './vendingMachine';
import user from './user';
import analytics from './analytics';
import contacts from './contacts';
import coffeeMachine from './coffeeMachine';
import warehouse from './warehouse';
import customerSupport from './customer-support';

const api = {
  auth,
  clients,
  overview,
  analytics,
  partner,
  product,
  routes,
  schedules,
  vendingMachine,
  user,
  contacts,
  coffeeMachine,
  warehouse,
  customerSupport,
};

export default api;
